import { AdKind } from '@/api/types/common.types';

export const KIND_ICON_NAMES = {
  [AdKind.Vipped]: 'vip',
  [AdKind.Premium]: 'crown',
  [AdKind.Bumped]: '',
};
